module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/carton3.df826324.jpg";